// extracted by mini-css-extract-plugin
export var dateLabel = "_4j-0";
export var dateLabelError = "_4j-1";
export var fullWidth = "_4j-2";
export var smaller = "_4j-3";